<template>
    <section class="app-notfound-view container-fluid">
        <div class="app-view-header d-flex flex-wrap justify-content-center">
            <div class="app-view-header__headline-wrap d-flex align-items-center">
                <span class="app-view-header__headline-wrap-pseudo-helper"></span>
                <h1 class="app-view-header__headline h2">404</h1>
                <span class="app-view-header__headline-wrap-pseudo-helper"></span>
            </div>
        </div>
        <div class="app-notfound-view__main">
            <slot>The product you are looking for could not be found.</slot>
        </div>
    </section>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style scoped>
    .app-notfound-view {
        position: relative;
        max-width: 600px;
        padding-bottom: 20px;
    }
    .app-notfound-view__main {
        margin-bottom: 2em;
        padding: 2em;
        background-color: #fff;
        text-align: center;
    }
</style>
